module.exports = __webpack_public_path__ + "static/media/hcoe.5bb74408.png";